 import cowPicture from '@/assets/tl/cow2.jpg'
 import icon1 from '@/assets/tl/icon1.png'
 import icon2 from '@/assets/tl/icon2.png'
 import icon3 from '@/assets/tl/icon3.png'
 import icon4 from '@/assets/tl/icon4.png'
 import icon5 from '@/assets/tl/icon5.png'
 import productImg from '@/assets/tl/product.png'
 import icon6 from '@/assets/tl/product-icon.png'



var infoData = [
    {
        "name": "产品",
        "icon": `${icon6}`,
        "img": `${productImg}`,
        "type": '',
        "data": [
            {
                "name": "产品名称",
                "value": "牛腿"
            },
            {
                "name": "净含量",
                "value": "500g"
            },
            {
                "name": "产品执行标准",
                "value": "GB/T 17238"
            },
            {
                "name": "贮存条件",
                "value": "-18C以下保存"
            },
            {
                "name": "保质期",
                "value": "12个月"
            },
            {
                "name": "配料",
                "value": "牛肉"
            },
            {
                "name": "生产日期",
                "value": "2023年07月13日"
            },
        ],
        "no": 1
    },
    {
        "name": "出生",
        "icon": `${icon1}`,
        "img": `${cowPicture}`,
        "type": 1,
        "data": [
            {
                "name": "出生日期",
                "value": "2021-06-10"
            },
            {
                "name": "耳标",
                "value": "DF00610"
            },
            {
                "name": "性别",
                "value": "雄性"
            },
            {
                "name": "种类",
                "value": "西门塔尔"
            },
            {
                "name": "父亲耳标",
                "value": "DF00595"
            },
            {
                "name": "父亲品种",
                "value": "西门塔尔"
            },
            {
                "name": "母亲耳标",
                "value": "DF00598"
            },
            {
                "name": "母亲品种",
                "value": "西门塔尔"
            }
        ],
        "no": 2
    },
    // {
    //     "name": "入群",
    //     "icon": `${icon2}`,
    //     "type": 1,
    //     "data": [
    //         {
    //             "name": "入群日期",
    //             "value": "2021-06-10"
    //         },
    //         {
    //             "name": "圈舍名称",
    //             "value": "3号圈"
    //         },
    //         {
    //             "name": "分社人",
    //             "value": "王延海"
    //         },
    //     ],
    //     "no": 2
    // },
    {
        "name": "检疫记录",
        "icon": `${icon3}`,
        "type": 1,
        "data": [
            {
                "name": "检验检疫日期",
                "value": "2021-06-10"
            },
            {
                "name": "检疫项目",
                "value": "口蹄疫"
            },
            {
                "name": "检疫人",
                "value": "王延海"
            },
        ],
        "no": 3
    },
    {
        "name": "免疫记录",
        "icon": "http://yj.east-mind.com:8097/lib/icon/002.png",
        "type": 1,
        "data": [
            {
                "name": "接种日期",
                "value": "2022-1-11"
            },
            {
                "name": "疫苗名称",
                "value": "口蹄疫疫苗"
            },
            {
                "name": "剂量",
                "value": "1.1ml"
            },
            {
                "name": "疫苗厂家",
                "value": "金宇保灵"
            },
            {
                "name": "疫苗批次",
                "value": "21370704"
            },
            // {
            //     "name": "兽医",
            //     "value": "王延海"
            // }
        ],
        "no": 4
    },
    // {
    //     "name": "首次治病",
    //     "icon": "http://yj.east-mind.com:8097/lib/icon/004.png",
    //     "type": 1,
    //     "data": [
    //         {
    //             "name": "治病日期",
    //             "value": "无"
    //         },
    //         {
    //             "name": "疾病类型",
    //             "value": "无"
    //         },
    //         {
    //             "name": "并发症状",
    //             "value": "无"
    //         },
    //         {
    //             "name": "发病原因",
    //             "value": "无"
    //         },
    //         {
    //             "name": "治疗方案",
    //             "value": "无"
    //         },
    //         {
    //             "name": "治病结果",
    //             "value": "无"
    //         },
    //         {
    //             "name": "兽医",
    //             "value": "王延海"
    //         }
    //     ],
    //     "no": 5
    // },
    {
        "name": "日增重趋势",
        "icon": `${icon4}`,
        "type": '',
        "data": [
            {
                "name": "",
                "value": ""
            }
        ],
        "no": 5
    },
    {
        "name": "入厂",
        "icon": "http://yj.east-mind.com:8097/lib/icon/006.png",
        "type": 2,
        "data": [
            {
                "name": "入厂时间",
                "value": "2023.7.10"
            },
            {
                "name": "耳标",
                "value": "DF00610"
            },
            {
                "name": "收购企业",
                "value": "内蒙古草原牛王肉业有限公司"
            },
            {
                "name": "收购地址",
                "value": "开鲁县开鲁镇梨树村08-1203588号"
            }
        ],
        "no": 6
    },
    // {
    //     "name": "动检报告",
    //     "icon": "http://yj.east-mind.com:8097/lib/icon/007.png",
    //     "type": 2,
    //     "data": [
    //         {
    //             "name": "检验检疫日期",
    //             "value": "2023.7.6"
    //         },
    //         {
    //             "name": "检疫人",
    //             "value": "王延海"
    //         }
    //     ],
    //     "no": 7
    // },
    {
        "name": "屠宰",
        "icon": "http://yj.east-mind.com:8097/lib/icon/008.png",
        "type": 2,
        "data": [
            {
                "name": "屠宰日期",
                "value": "2023.7.11"
            },
            {
                "name": "屠宰人",
                "value": "曹宇"
            }
        ],
        "no": 7
    },
    // {
    //     "name": "宰中检验",
    //     "icon": "http://yj.east-mind.com:8097/lib/icon/009.png",
    //     "type": 2,
    //     "data": [
    //         {
    //             "name": "检验日期",
    //             "value": "2023.7.11"
    //         },
    //         {
    //             "name": "检验人",
    //             "value": "高维星"
    //         }
    //     ],
    //     "no": 9
    // },
    // {
    //     "name": "检斤称重",
    //     "icon": "http://yj.east-mind.com:8097/lib/icon/010.png",
    //     "type": 2,
    //     "data": [
    //         {
    //             "name": "检斤时间",
    //             "value": "2023.7.11 17:00"
    //         },
    //         {
    //             "name": "检斤人",
    //             "value": "王永强"
    //         }
    //     ],
    //     "no": 10
    // },
    {
        "name": "宰后检疫",
        "icon": "http://yj.east-mind.com:8097/lib/icon/011.png",
        "type": 2,
        "data": [
            {
                "name": "检疫时间",
                "value": "2023.7.11 17:20"
            },
            {
                "name": "检疫人",
                "value": "闫大伟"
            }
        ],
        "no": 8
    },
    {
        "name": "排酸",
        "icon": "http://yj.east-mind.com:8097/lib/icon/012.png",
        "type": 2,
        "data": [
            {
                "name": "排酸时间",
                "value": "2023.7.11 17:50"
            },
            {
                "name": "操作人",
                "value": "王鑫"
            }
        ],
        "no": 9
    },
    {
        "name": "分割",
        "icon": `${icon5}`,
        "type": 2,
        "data": [
            {
                "name": "分割时间",
                "value": "2023.7.13 14:40"
            },
            {
                "name": "分割人",
                "value": "徐文"
            }
        ],
        "no": 10
    },
    {
        "name": "急冻",
        "icon": "http://yj.east-mind.com:8097/lib/icon/017.png",
        "type": 2,
        "data": [
            {
                "name": "急冻时间",
                "value": "2023.7.13 15:30"
            },
            {
                "name": "操作人",
                "value": "王永才"
            }
        ],
        "no": 11
    },
    {
        "name": "入库",
        "icon": "http://yj.east-mind.com:8097/lib/icon/018.png",
        "type": 2,
        "data": [
            {
                "name": "入库时间",
                "value": "2023.7.13 16:00"
            },
            {
                "name": "库管员",
                "value": "屠兴龙"
            }
        ],
        "no": 12
    },
    // {
    //     "name": "分销",
    //     "icon": "http://yj.east-mind.com:8097/lib/icon/016.png",
    //     "type": 2,
    //     "data": [
    //         {
    //             "name": "下单时间",
    //             "value": "2023.7.13 16:30"
    //         },
    //         {
    //             "name": "业务员",
    //             "value": "张云皓"
    //         }
    //     ],
    //     "no": 16
    // },
    {
        "name": "出库",
        "icon": "http://dataprod.east-mind.com/img/020.aadd1eff.png",
        "type": 2,
        "data": [
            {
                "name": "出库时间",
                "value": "2023.7.14 08:30"
            },
            {
                "name": "库管员",
                "value": "丁日椿"
            }
        ],
        "no": 13
    },
    // {
    //     "name": "冷链",
    //     "icon": "http://yj.east-mind.com:8097/lib/icon/018.png",
    //     "type": 2,
    //     "data": [
    //         {
    //             "name": "装车时间",
    //             "value": "2023.7.14 09:00"
    //         },
    //         {
    //             "name": "司机",
    //             "value": "王宇"
    //         }
    //     ],
    //     "no": 18
    // },
    // {
    //     "name": "门店入库",
    //     "icon": "http://yj.east-mind.com:8097/lib/icon/019.png",
    //     "type": 0,
    //     "data": [
    //         {
    //             "name": "入库时间",
    //             "value": "2023.7.14 11:40"
    //         },
    //         {
    //             "name": "库管员",
    //             "value": "孙家英"
    //         }
    //     ],
    //     "no": 19
    // }



]
export default infoData